/*export const MOCK_DATA_PAYMENTS = [
	{ id: 1, list: null, numberOfDate: 28 },
	{ id: 2, list: null, numberOfDate: 29 },
	{ id: 3, list: null, numberOfDate: 30 },
	{ id: 4, list: null, numberOfDate: 31 },
	{ id: 5, list: [ 'John Dou $1235' ], numberOfDate: 1 },
	{ id: 6, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 2 },
	{ id: 7, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 3 },
	{ id: 8, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 4 },
	{ id: 9, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 5 },
	{ id: 10, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 6 },
	{ id: 11, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 7 },
	{ id: 12, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 8 },
	{ id: 13, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 9 },
	{ id: 14, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 10 },
	{ id: 15, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 11 },
	{ id: 16, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 12 },
	{ id: 17, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 13, isToday: true },
	{ id: 18, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 14 },
	{ id: 19, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 15 },
	{ id: 20, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 16 },
	{ id: 21, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 17 },
	{ id: 22, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 18 },
	{ id: 23, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 19 },
	{ id: 24, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 20 },
	{ id: 25, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 21 },
	{ id: 26, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 22 },
	{ id: 27, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 23 },
	{ id: 28, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 24 },
	{ id: 29, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 25 },
	{ id: 30, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 26 },
	{ id: 31, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 27 },
	{ id: 32, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 28 },
	{ id: 33, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 29 },
	{ id: 34, list: [ 'John Dou $1235', 'Michael jackson $120' ], numberOfDate: 30 },
	{ id: 35, list: null, numberOfDate: 1 },
];*/

export const daysOfWeek = [
	'SUN',
	'MON',
	'TUE',
	'WED',
	'THU',
	'FRI',
	'SAT'
];
